import React from 'react';
import { MapPin } from 'lucide-react';
import { siteConfig } from '../data/mock';

const AboutSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.phone}?text=${encodeURIComponent('Olá! Gostaria de mais informações sobre rastreamento veicular em Sorocaba.')}`;

  return (
    <section className="bg-[#0a0f1e] py-20">
      <div id="sobre-nos" className="container mx-auto px-6 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="inline-block bg-blue-600/20 border border-blue-500/30 rounded-full px-4 py-1.5">
                <span className="text-blue-400 text-sm font-semibold uppercase tracking-wider">Sobre Nós</span>
              </div>

              <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight">
                <span className="text-blue-500">GoProtege:</span> A Empresa de Rastreamento Veicular de Confiança em Sorocaba
              </h2>

              <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
                <p>
                  A <strong className="text-blue-400">GoProtege</strong> é uma empresa especializada em{' '}
                  <strong className="text-white">rastreamento veicular em Sorocaba e região</strong>. Atuamos tanto para pessoa física 
                  quanto para empresas que precisam de <strong className="text-white">rastreamento de frotas em Sorocaba/SP</strong>.
                </p>

                <p>
                  Nossa missão é simples: entregar a melhor tecnologia de rastreamento automotivo com o atendimento próximo e 
                  personalizado que só uma empresa local pode oferecer. Sabemos as necessidades dos motoristas de Sorocaba porque somos daqui.
                </p>

                <p>
                  Trabalhamos com tecnologia homologada, plataforma web e app completo, instalação no endereço do cliente e suporte 
                  técnico especializado. Sorocaba, Votorantim, Salto, Itu, Porto Feliz e toda a região têm acesso aos nossos serviços.
                </p>
              </div>
            </div>

            {/* Right Content - Location Card */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_tracker-clone/artifacts/4hstr96v_Gemini_Generated_Image_e9dmbue9dmbue9dm.png"
                  alt="Localização GoProtege em Sorocaba/SP"
                  className="w-full h-[400px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-950/90 via-blue-950/30 to-transparent"></div>
                
                {/* Location Info */}
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="bg-slate-900/90 backdrop-blur-sm border border-blue-500/20 rounded-xl p-6">
                    <div className="flex items-start gap-4 mb-4">
                      <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <MapPin className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <h3 className="text-white font-bold text-lg mb-1">GoProtege</h3>
                        <p className="text-gray-300 text-sm">Sorocaba - Alto da Boa Vista</p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between pt-4 border-t border-blue-500/20">
                      <div className="flex items-center gap-2">
                        <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                        <span className="text-green-400 text-sm font-medium">Atendimento Imediato</span>
                      </div>
                      <span className="text-gray-400 text-sm">Sorocaba e toda a região</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center mt-12">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-green-500/50 hover:scale-105"
            >
              Falar com Especialista Agora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
